import React, { useState,useEffect, useRef  } from "react";
import { useParams } from "react-router";
import {
  IonButtons,
  IonButton,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonItem,
  IonLabel,
  IonInput,
  IonToast,
  IonText,
  IonPage,
  IonContent,
  IonAlert,
  IonFooter,
  IonTextarea,
  IonList,
  IonIcon,
  IonModal,
  IonImg,
  IonFab, IonFabButton, IonFabList,IonRouterLink
} from "@ionic/react";
import { useHistory, Link } from "react-router";
import * as firebase from "firebase";
import { observer, MobXProviderContext } from "mobx-react";
import * as icons from 'ionicons/icons';
import PhoneInput from 'react-phone-number-input';
import ReCAPTCHA from "react-google-recaptcha";
import InputMask from 'react-input-mask';
function ConnectInput(props) {
  return (
    <InputMask 
      mask='999-999' 
      value={props.value} 
      onChange={props.onChange} onKeyDown={props.onKeyDown} className="coninp" placeholder="Remote ID">
    </InputMask>
  );
}

const TabOnePage = ({ addItem }) => {
  const { store } = React.useContext(MobXProviderContext);
  let { isAuth, initializationError } = store;
  const history = useHistory();
  const [remote_user_id, setRemoteUserId] = useState("000000");
  const [remote_user_name, setRemoteUserName] = useState(null);
  const [user_id, setUserId] = useState("000000");
  const [session_id, setSessionId] = useState("");
  const [errorInfo, setErrorInfo] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [connected, setConnected] = useState(false);
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [editable, setEditable] = useState(false);
  const [editing, setEditing] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [subdesc, setSubdesc] = useState([]);
  const [captcha, setCaptcha] = useState(null);
  const [mid, setMid] = useState("");
  const params = useParams();
  const contentRef = useRef(null)
  const [disconnected, setDisconnected] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [accountId, setAccountId] = useState(null);
  const [accountData, setAccountData] = useState({newbuttons:[{icon:'at',name:'Email',data:''},{icon:'call',name:'Phone',data:''},{icon:'location',name:'Location',data:''},{icon:'person',name:'Name',data:''},{icon:'logoLinkedin',name:'Linkedin',data:''}]});
  const modal = useRef(null);
  const input = useRef(null);
  const inputFile = useRef(null);
  const [upTxt, setUpTxt] = useState(null);
  const [showLink, setShowLink] = useState(false);
  const timer = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [showClose, setShowClose] = useState(true);

  /**
   *
   */
  const [codeCopied, setCodeCopied] = useState(false);

  const copySessionCode = async () => {
    const rawCode = user_id.toString().replace('U', '').replace(/\s/g, '');
    try {
      await navigator.clipboard.writeText(rawCode);
      setCodeCopied(true);
      setErrorInfo({ showErrorToast: true, errMsg: 'Code copied!' });
      setTimeout(() => setCodeCopied(false), 1500);
    } catch (e) {
      setErrorInfo({ showErrorToast: true, errMsg: 'Failed to copy code' });
    }
  };

  const handleRemoteIdChange = (e) => {
    const digits = e.target.value.replace(/\D/g, '').slice(0, 6);
    const formatted = digits.length > 3 ? `${digits.slice(0, 3)} ${digits.slice(3)}` : digits;
    setRemoteUserId(formatted);
    setErrorInfo({});
  };

  const isRemoteIdValid = remote_user_id ? remote_user_id.toString().replace(/\D/g, '').length === 6 : false;

  /**
   *
   */
  const _doLogin = async () => {
    if (remote_user_id.length==0) {setErrorInfo({showErrorToast:true,errMsg:'Enter Remote ID!'});return;}
    if(remote_user_id.replace('-','')==user_id.replace('-','')){setErrorInfo({showErrorToast:true,errMsg:'Invalid Remote ID!'});return;}
    setConnected(true);
    firebase
    .firestore()
    .collection("users")
    .doc('U'+remote_user_id.replace('-',''))
    .set({
      user_id:'U'+remote_user_id.replace('-',''),
      request:true,
      ruser_id:'U'+user_id,
      connected:false,
      ruser_name:accountData?.name?accountData?.name:null
    });
    firebase.firestore().collection('users').doc('U'+remote_user_id.replace('-','')).get().then(results => {
      if(results.exists){
      }
      else{
        setErrorInfo({showErrorToast:true,errMsg:'Invalid Remote ID!'});
        setConnected(false);
      }
    });
    updateAccountData();
  };

  useEffect(() => {
    return handleClick();
  }, []);
  useEffect(() => {
    if(params?.ruserId){
      window.localStorage.setItem('userid',params?.ruserId);
    }
    if(params?.userId){
      window.localStorage.setItem('ruserid','U'+params?.userId);
      setTimeout(()=>{
        connectUser();
      },300);
    }
  }, [params]);
  useEffect(() => {
    const tabBar = document.querySelector('ion-tab-bar');
    if (tabBar) {
      if (connected) {
        tabBar.style.display = 'none';
      } else {
        tabBar.style.display = 'flex';
      }
    }
    return () => {
      if (tabBar) tabBar.style.display = 'flex';
    };
  }, [connected]);
  useEffect(() => {
    scrollToBottom();
    if(timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(()=>{
      if(!disconnected){
        setDisconnected(true);
      }
    },900000);
  }, [messages]);
  useEffect(() => {
    updateAccountData();
    setAccountId(window.localStorage.getItem('account_id'));
    if(history.location.pathname=="/tabs/home/link"){
      setShowLink(true);
    }
  }, [history.location]);
  const scrollToBottom = () => {
    if (contentRef.current) {
      contentRef.current.scrollToBottom(500);
    }
  }
  const disConnect = () =>{
    if(window.localStorage.getItem('account_id')==null || window.localStorage.getItem('account_id')==undefined || window.localStorage.getItem('account_id')==''){setShowConfirm(true);}
    firebase
      .firestore()
      .collection("users")
      .doc('U'+remote_user_id)
      .set({
        user_id:'U'+remote_user_id,
        request:false,
        ruser_id:'U'+user_id,
        connected:false,
        ruser_name:accountData?.name?accountData?.name:null
      });
    firebase
      .firestore()
      .collection("users")
      .doc('U'+user_id)
      .set({
        user_id:'U'+user_id,
        request:false,
        ruser_id:'U'+remote_user_id,
        connected:false,
        ruser_name:remote_user_name
      });
  }
  const handleClick = () =>{
    const onResult = (querySnapshot)=>{
      var data = querySnapshot.data();
      if(data.ruser_id!="" && data.ruser_id!=undefined && data.ruser_id!=null){
        window.localStorage.setItem('ruserid',data.ruser_id);
      }
      if(data.ruser_name!="" && data.ruser_name!=undefined && data.ruser_name!=null){
        window.localStorage.setItem('rusername',data.ruser_name);
      }
      if(data.request){
        connectUser(data);
      }
      if(data.connected){
        setConnected(true);
        setDisconnected(false);
        initMessages(data);
      }
      else if(!data.request){
        setConnected(false);
        setRemoteUserId("");
        if(window.localStorage.getItem('account_id')){
          if(data?.ruser_id){
            let rid = parseFloat(data.ruser_id.replace('U',''));
            let uid = parseFloat(data.user_id.replace('U',''));
            var mid1 = uid>rid?rid+'_'+uid:uid+'_'+rid;
            let messages1=[];
            firebase.firestore().collection('messages').doc(mid1).collection('list').get().then(results => {
              results.docs.forEach(d=>{
                messages1.push(d.data());
              });
              firebase.firestore().collection('history').doc(window.localStorage.getItem('account_id')).collection('data').add({ruser_id:data.ruser_id,ruser_name:data.ruser_name,messages:messages1,date:new Date()});
            });
            setTimeout(()=>{
              firebase.firestore().collection('messages').doc(mid1).collection('list').get().then(results => {
                results.docs.forEach(d=>{
                  d.ref.delete();
                });
              });
            },3000);
          }
        }
      }
    }
    const onError = (error)=>{

    }

    var rand = "";
    if(window.localStorage.getItem('userid')==null){
      const min = 100000;
      const max = 999999;
      rand = Math.round(min + Math.random() * (max - min));
      window.localStorage.setItem('userid',rand);
    }
    else{
      rand = window.localStorage.getItem('userid');
    }
    updateAccountData();
    setUserId(rand);
    setAccountId(window.localStorage.getItem('account_id'));
    store.doCreateUser({user_id:'U'+rand});
    const unsubscribe = firebase.firestore().collection('users').doc('U'+rand).onSnapshot(onResult, onError);
    return unsubscribe;
  }
  const updateAccountData =()=>{
    if(window.localStorage.getItem('account_data')!==null){
      let adata = JSON.parse(window.localStorage.getItem('account_data'));
      if (adata.newbuttons==null || adata.newbuttons==undefined || adata.newbuttons=='') {
        adata.newbuttons=[{icon:'at',name:'Email',data:''},{icon:'call',name:'Phone',data:''},{icon:'location',name:'Location',data:''},{icon:'logoLinkedin',name:'Linkedin',data:''}];
      }
      else{
        let newbuttons1 = adata.newbuttons;
        adata.newbuttons = [{icon:'at',name:'Email',data:''},{icon:'call',name:'Phone',data:''},{icon:'location',name:'Location',data:''},{icon:'person',name:'Name',data:''},{icon:'logoLinkedin',name:'Linkedin',data:''}];
        newbuttons1.forEach((d,k)=>{
          if(k<5){
            adata.newbuttons[k].icon=d.icon;
            adata.newbuttons[k].name=d.name;
            adata.newbuttons[k].data=d.data;
          }
          else{
            adata.newbuttons.push(d);
          }
        });
      }
      setAccountData(adata);
    }
  }
  const copyText = (text) =>{
    if(text.includes(': ')){
      let text1 = text.split(': ');
      navigator.clipboard.writeText(text1[1]);
    }
    else navigator.clipboard.writeText(text);
    setErrorInfo({showErrorToast:true,errMsg:'Copied!'});
  }
  const initMessages = async(data)=>{
    let rid = parseFloat(data.ruser_id.replace('U',''));
    let uid = parseFloat(data.user_id.replace('U',''));
    setRemoteUserId(rid);
    setRemoteUserName(data.ruser_name);
    var mid1 = uid>rid?rid+'_'+uid:uid+'_'+rid;
    const onResult1 = (querySnapshot)=>{
      var marr = [];
      querySnapshot.forEach(d=>{
        let a = d.data();console.log(a)
        if(data.user_id!=a.from) setEditable(true);
        if (a.message=='Started') {
          JSON.parse(a.questions).forEach(f=>{
            marr.push({question:f[0].trim(),answer:f[1]?f[1].trim():''});
            setQuestions([...marr])
          });
          setMessages([a]);
          setCurrentIndex(a.currentIndex);
          setCurrentQuestion(marr[a.currentIndex]);
          setSubdesc(a.subdesc?JSON.parse(a.subdesc):[]);
          setEditing(data.user_id==a.editing);
        }
        if (a.message=='Completed') {
          JSON.parse(a.questions).forEach(f=>{
            marr.push(f);
            setQuestions([...marr])
          });
          setMessages([a]);
          setCurrentQuestion(marr[0]);
        }
      });
    }
    const onError1 = (error)=>{

    }
    setMid(mid1);
    const unsubscribe = firebase.firestore().collection('messages').doc(mid1).collection('list').orderBy('date', 'asc').onSnapshot(onResult1, onError1);
    // const batch = firebase.firestore().batch();
    // const snapshop = await firebase.firestore().collection('messages').doc(mid1).collection('list').orderBy('date', 'asc').get();
    // snapshop.docs.forEach((doc) => {
    //     batch.delete(doc.ref);
    //   });
    // await batch.commit();
    // snapshot.docs.forEach((doc) => {
    //   batch.delete(doc.ref);
    // });
  }
  const connectUser = (data) => {
    let ruser_id = window.localStorage.getItem('ruserid');
    let ruser_name = window.localStorage.getItem('rusername');
    let user_id = window.localStorage.getItem('userid');
    let accountData = JSON.parse(window.localStorage.getItem('account_data'));
    setRemoteUserName(ruser_name);
    firebase
      .firestore()
      .collection("users")
      .doc(ruser_id)
      .set({
        user_id:ruser_id,
        request:false,
        ruser_id:'U'+user_id,
        connected:true,
        ruser_name:accountData?.name?accountData?.name:null
      });
    firebase
      .firestore()
      .collection("users")
      .doc('U'+user_id)
      .set({
        user_id:'U'+user_id,
        request:false,
        ruser_id:ruser_id,
        connected:true,
        ruser_name: ruser_name
      });
      updateAccountData();
  }
  const _sendMessage = () => {
    if(message!="" || (upTxt!=null && upTxt!='Uploading...')){
      // let msg = message;
      // if((upTxt!=null && upTxt!='Uploading...')) msg+=' '+upTxt;
      // console.log(msg)
      // firebase.firestore().collection('messages').doc(mid).collection('list').add({message:msg,from:user_id,date:new Date()});
      // setMessage("");
      // removeFile(null);
      let msg = message;
      let qu = currentQuestion;
      qu.answer = msg;
      questions[currentIndex].answer = msg;
      setCurrentQuestion(qu);
      setQuestions(questions);
      setMessage("");
      setShowClose(true);
      let q = currentIndex;
      let qs = questions;
      if (qs[q]) {
        let rows = [];
        questions.forEach(q=>{
          rows.push([q.question,q.answer]);
        });
        firebase.firestore().collection('messages').doc(mid).collection('list').doc('questions').set({message:'Started',from:editable?'U'+remote_user_id:'U'+user_id,date:new Date(),questions:JSON.stringify(rows),currentIndex:q,subdesc:JSON.stringify(subdesc)});
      }
    }
  }
  const _doSendLink = (phone) =>{
    fetch('https://onehotcode.com/api.php?action=sendlink&phone='+phone+'&user_id='+user_id);
    setErrorInfo({showErrorToast:true,errMsg:'Link sent'});
  }
  const _handleKeyDown = (e) =>{
    if (e.key === 'Enter') {
      _sendMessage();
    }
  }
  const _handleDataButton = (t,tp) =>{
    if(window.localStorage.getItem('account_id')){
      let message1="";
      let ad = JSON.parse(window.localStorage.getItem('account_data'));
      if(ad){
        message1=t;
        if (message1!="") {
          if(tp==1){
            setMessage(message1);
          }
          else{
            firebase.firestore().collection('messages').doc(mid).collection('list').add({message:message1,from:user_id,date:new Date()});
          }
        }
        else{
          return history.replace("/tabs/edit");
        }
      }
      else{
        return history.replace("/tabs/edit");
      }
    }
    else{
      return history.replace("/tabs/settings");
    }
  }
  const confirm = () => {
    if(input.current?.value.length>9 && captcha!==null){
      setShowAlert(false);
      _doSendLink(input.current?.value.replace(/ /g, ''));
    }
    if(captcha==null){
      setErrorInfo({showErrorToast:true,errMsg:'Select captcha!'});
    }
  }

  const onWillDismiss = (ev)=>{
    if (ev.detail.role === 'confirm') {
      setMessage(`Hello, ${ev.detail.data}!`);
    }
  }
  const onChangeCaptcha = (v) => {
    setCaptcha(v)
  }
  const onButtonClick = () => {
   inputFile.current.click();
  };
  const handleImageUpload = event => {
    // setUpTxt('Uploading...');
    const files = event.target.files
    // const formData = new FormData()
    // formData.append('myFile', files[0]);
    // console.log(files[0])

    // fetch('https://onehotcode.com/api.php?action=savefile', {
    //   method: 'POST',
    //   body: formData
    // })
    // .then(response => response.json())
    // .then(data => {
    //   setUpTxt('<a target="_blank" href="https://onehotcode.com/uploads/'+data.filepath+'">'+data.filename+'</a>');
    // })
    // .catch(error => {
    //   // console.error(error)
    // })
    const reader = new FileReader();
    reader.onload = (event) => {
      const text = event.target?.result;
      const rows = text
        .trim()
        .split("\n")
        .map((row) => row.split(","));

      firebase.firestore().collection('messages').doc(mid).collection('list').doc('questions').set({message:'Started',from:user_id,date:new Date(),questions:JSON.stringify(rows),currentIndex:0,subdesc:JSON.stringify(subdesc)});
    };

    reader.readAsText(files[0]);
  }
  const removeFile = () => {
    setUpTxt(null);
    inputFile.current.value=null;
  }

  const nextQuestion = async() =>{
    let q = currentIndex;
    let qs = questions;
    q++;
    if (qs[q]) {
      setCurrentIndex(q);
      setCurrentQuestion(qs[q]);
      let rows = [];
      questions.forEach(q=>{
        rows.push([q.question,q.answer]);
      })
      firebase.firestore().collection('messages').doc(mid).collection('list').doc('questions').set({message:'Started',from:'U'+remote_user_id,date:new Date(),questions:JSON.stringify(rows),currentIndex:q,subdesc:JSON.stringify(subdesc)});
    }
    else{
      const batch = firebase.firestore().batch();
      const snapshop = await firebase.firestore().collection('messages').doc(mid).collection('list').orderBy('date', 'asc').get();
      snapshop.docs.forEach((doc) => {
        batch.delete(doc.ref);
      });
      await batch.commit();
      firebase.firestore().collection('messages').doc(mid).collection('list').doc('questions').set({message:'Completed',from:user_id,date:new Date(),questions:JSON.stringify(questions)});
    }
  }
  const prevQuestion = async() =>{
    let q = currentIndex;
    let qs = questions;
    q--;
    if (qs[q]) {
      setCurrentIndex(q);
      setCurrentQuestion(qs[q]);
      let rows = [];
      questions.forEach(q=>{
        rows.push([q.question,q.answer]);
      });
      firebase.firestore().collection('messages').doc(mid).collection('list').doc('questions').set({message:'Started',from:'U'+remote_user_id,date:new Date(),questions:JSON.stringify(rows),currentIndex:q,subdesc:JSON.stringify(subdesc)});
    }
  }
  const changeAnswer = () =>{
    setEditing(true);
    setShowClose(false);
    setTimeout(()=>{
      if(document.getElementsByClassName('chatbox') && document.getElementsByClassName('chatbox')[0]){
        document.getElementsByClassName('chatbox')[0].focus();
      }
    },100);
    setMessage(currentQuestion.answer);
    let q = currentIndex;
    let qs = questions;
    if (qs[q]) {
      let rows = [];
      questions.forEach(q=>{
        rows.push([q.question,q.answer]);
      });
      firebase.firestore().collection('messages').doc(mid).collection('list').doc('questions').set({message:'Started',from:editable?'U'+remote_user_id:'U'+user_id,date:new Date(),questions:JSON.stringify(rows),currentIndex:q,subdesc:JSON.stringify(subdesc),editing:'U'+user_id});
    }
  }
  const arrayToCsv = () => {
    const csvRows = [];
    for (const row of questions) {
      csvRows.push(row.question+", "+row.answer);
    }
    return csvRows.join('\n'); // Join rows with a newline character
  };
  const download = (data) => {
    const blob = new Blob([data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('hidden', '');
    a.setAttribute('href', url);
    a.setAttribute('download', `update_data.csv`);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
  const downloadQuestions = () => {
    const csvData = arrayToCsv();
    download(csvData);
  }

  return (
    <IonPage>
      {connected?<IonHeader>
        <div style={{textAlign:'center' }}><IonImg style={{width: '150px', display: 'inline-block', verticalAlign:'bottom', padding: '10px 0' }} src="/assets/img/logo.png" alt="Logo"></IonImg></div>
        <IonToolbar color="primary">
          
          <IonTitle style={{fontSize: '18px'}}>
            {disconnected?'Disconnected from':'Connected to'} {remote_user_id} {remote_user_name!=null?'('+remote_user_name.substring(0,8)+')':''}
          </IonTitle>
          <IonButtons slot="end">
            <IonButton className="logout" shape="round" onClick={disConnect} ><IonIcon  icon={icons['close']}></IonIcon></IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>:null}
      <IonContent className="ion-padding" ref={contentRef}>
        <IonModal className="sendlinkmodal" isOpen={showAlert} ref={modal} onWillDismiss={(ev) => onWillDismiss(ev)}>
          <IonContent className="ion-padding noscroll">
            <PhoneInput
          defaultCountry="IN"
          international={false}
          withCountryCallingCode
          countrySelectProps={{ disabled: true }}
          placeholder="Enter phone number"
          onChange={(e)=>{}}
          ref={input} />
          <div className="recaptcha_div">
            <ReCAPTCHA
              sitekey="6LcMOSEhAAAAANU2XLWBADtiCl-HLz9SDQ0jDdsW"
              onChange={onChangeCaptcha}
              className="grecaptcha"
            />
          </div>
          </IonContent>
          <IonFooter>
            <IonToolbar>
              <IonButtons slot="start">
                <IonButton onClick={() => setShowAlert(false)}>Cancel</IonButton>
              </IonButtons>
              <IonButtons slot="end">
                <IonButton strong={true} onClick={() => confirm()}>
                  Send
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonFooter>
        </IonModal>
        <IonAlert
          isOpen={showConfirm}
          onDidDismiss={() => setShowConfirm(false)}
          header="Confirm"
          message="Signup to save data!"
          buttons={['Cancel',{
                text: 'Signup',
                role: 'confirm',
                handler: (data) => {
                  let ruser_id = window.localStorage.getItem('ruserid');
                  let user_id = window.localStorage.getItem('userid');
                  let rid = parseFloat(ruser_id.replace('U',''));
                  let uid = parseFloat(user_id.replace('U',''));
                  var mid1 = uid>rid?rid+'_'+uid:uid+'_'+rid;
                  window.localStorage.setItem('mid1',mid1);
                  return history.replace("/tabs/settings");
                }
              }]}
        />
        <IonText color="danger" padding style={{ fontWeight: "500" }}>
          {initializationError && initializationError.message}
        </IonText>
        {connected?<div>
          <div className="messages">
            <IonList>
              {messages.map(function(d, idx){
                 return (<IonItem key={idx}>
                  {d.message=='Started'?(d.from==user_id?'Form data sent to user successfully. You can download the filled form once the user completes it.':(<div><div style={{padding:'0 15px',display:'flex', alignItems: 'center', gap: '10px'}}><div style={{display: 'flex',flexDirection: 'column'}}><b>{currentQuestion?.question}</b>{subdesc[currentIndex]?(<span>({subdesc[currentIndex]})</span>):''}</div>: {currentQuestion?.answer}</div>{showClose?<div>{editable?<IonButton className="green" onClick={() => nextQuestion()}><IonIcon icon={icons['checkmark']}
></IonIcon></IonButton>:null} <IonButton onClick={() => changeAnswer()}>Edit</IonButton> {currentIndex>0 && editable?<IonButton onClick={() => prevQuestion()}>Back</IonButton>:null}</div>:null}</div>)):(d.message=='Completed'?((d.from==user_id?'Verification Completed. Thank you!':<IonButton onClick={() => downloadQuestions()} style={{height: '40px'}}>Validation Complete  <IonIcon icon={icons['arrowDown']}
></IonIcon></IonButton>)):null) }</IonItem>)
               })}
            </IonList>
          </div>
          
        </div>:<div className="app-panel-view">
        <div className="app-head">
          <h3>My One<span style={{ color: "var(--red)" }}>Hot</span>Code</h3>
          <span className="ready"><i></i> Ready to connect</span>
        </div>

        <div className="session-box">
          <div className="session-meta">
            <span className="small-label">YOUR CODE</span>
            <strong id="sessionCode">
              {user_id.toString().replace('U', '').replace(/\B(?=(\d{3})+(?!\d))/g, " ")}
            </strong>
            <button
              id="copyCode"
              type="button"
              className="copy-button"
              onClick={copySessionCode}
              aria-label="Copy session code"
            >
              <span>{codeCopied ? '✓' : '⧉'}</span> {codeCopied ? 'Copied' : 'Copy code'}
            </button>
          </div>
        </div>

        <p className="hint">Share this code with the person you're speaking with, or let them scan it.</p>

        <div className="or-row"><span>OR CONNECT TO SOMEONE</span></div>

        <div className="connect-input-block">
          <label htmlFor="remoteId">Remote ID</label>
          <input
            id="remoteId"
            type="text"
            inputMode="numeric"
            autoComplete="off"
            maxLength={7}
            placeholder="e.g. 123 456"
            value={remote_user_id}
            onChange={handleRemoteIdChange}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.keyCode === 13) {
                _doLogin();
              }
            }}
          />
          <button
            id="connectBtn"
            type="button"
            className={`connect-button ${isRemoteIdValid ? 'enabled' : ''}`}
            disabled={!isRemoteIdValid}
            onClick={_doLogin}
          >
            Connect
          </button>
          <div className="connect-feedback" id="connectFeedback" aria-live="polite">
            {errorInfo.errMsg && !errorInfo.showErrorToast ? errorInfo.errMsg : ''}
          </div>

          {showLink && (
            <button
              type="button"
              className="sms-link-btn"
              onClick={() => setShowAlert(true)}
            >
              SMS Link to Connect
            </button>
          )}
        </div>

        <section className="mobile-marketing-card" aria-label="OneHotCode overview">
          <span className="icon-tile red">⚡</span>
          <div>
            <h2>Transform customer calls into <span className="accent-red">secure,</span> <span className="accent-teal">real-time</span> digital workflows.</h2>
            <p>See how OneHotCode works.</p>
          </div>
          <a href="https://calendly.com/onehotcode2026/30min" target="_blank" rel="noopener noreferrer" className="arrow-link" aria-label="See more">›</a>
        </section>

        <div className="powered">
          Powered by <a href="https://aekam.ai/" target="_blank" rel="noopener noreferrer"><strong>Aekam.ai</strong></a>
        </div>
        </div>}
        <IonToast
          color="dark"
          isOpen={errorInfo.showErrorToast}
          onDidDismiss={() => setErrorInfo({ showErrorToast: false })}
          message={errorInfo.errMsg}
          position="middle"
          duration={2000}
        />
        {/*{connected && !disconnected && accountData?.newbuttons.length>4?<IonFab slot="fixed" vertical="bottom" className="homebutton" horizontal="start">
            <IonFabButton close-icon={'remove'}>
              <IonIcon icon={icons['add']}></IonIcon>
            </IonFabButton>
            <IonFabList side="top">
              {accountData?.newbuttons.map(function(d, idx){
                return idx>4?<IonFabButton key={'m'+idx} onClick={()=>_handleDataButton(d.name+': '+d.data,1)}><IonIcon icon={icons[d.icon]}></IonIcon></IonFabButton>:null
              })}
            </IonFabList>
          </IonFab>:null}*/}
      </IonContent>
      {connected && !disconnected && editing?<IonFooter><div className="chatwrap"><IonItem>
          <IonTextarea onKeyDown={_handleKeyDown} className="chatbox"
            onIonChange={(e) => {
              setMessage(e.detail.value);
            }}
            value={message}
            name="message"
          />
        </IonItem>
        <IonButton
            expand="full"
            className="chatsend"
            onClick={(e) => {
              if (!e.currentTarget) {
                return;
              }
              e.preventDefault();
              _sendMessage();
            }}
          >
            <IonIcon icon={icons['paperPlane']} style={{ color: 'white' }}></IonIcon>
          </IonButton>
          <div className={upTxt=='Uploading...'?'upstatus loading':'upstatus'}><div dangerouslySetInnerHTML={{ __html: upTxt }}></div>{upTxt!=null && upTxt!='Uploading...'?(<IonIcon onClick={()=>removeFile()} icon={icons['close']}></IonIcon>):null}</div>
          </div>
          <input type='file' id='file' accept=".csv" onChange={(e)=>handleImageUpload(e)} ref={inputFile} style={{display: 'none'}}/>
          <div className="shortcuts" onClick={()=>onButtonClick()}>Upload Validation Data <IonIcon icon={icons['attach']}></IonIcon></div>
          {/*<div className="shortcuts">
            {accountData?.name?(<IonIcon onClick={()=>onButtonClick()} icon={icons['attach']}></IonIcon>):null}
            {accountData?.newbuttons.map(function(d, idx){
              return idx<5?<IonIcon key={'m'+idx} style={{color:d.data==''?'darkgrey':'black'}} onClick={()=>_handleDataButton(d.name+': '+d.data,1)} icon={icons[d.icon]}></IonIcon>:null
            })}
          </div>
          {accountData?.name && accountData?.newbuttons.length<10?<IonItem routerLink="/tabs/edit" className="mylink">
            <IonLabel>Add shortcuts</IonLabel>
          </IonItem>:null}*/}
        </IonFooter>:null}
    </IonPage>
  );
};

export default observer(TabOnePage);


